module.exports = __webpack_public_path__ + "img/prenatal_appointment.2033b1e8.png";